<app-toast></app-toast>
<app-rotation-warning></app-rotation-warning>
<router-outlet></router-outlet>
